export default __webpack_public_path__ + "static/today-knee-us-1-ebb07830ec82afba4cc149c16b50edac.jpg";